import { render, staticRenderFns } from "./Definition.vue?vue&type=template&id=afced5fa&scoped=true&"
import script from "./Definition.vue?vue&type=script&lang=js&"
export * from "./Definition.vue?vue&type=script&lang=js&"
import style0 from "./Definition.vue?vue&type=style&index=0&id=afced5fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afced5fa",
  null
  
)

export default component.exports